import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MenuInputComponent } from './menu-input.component';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatMenuModule } from '@angular/material/menu';

@NgModule({
  declarations: [MenuInputComponent],
  imports: [CommonModule, ReactiveFormsModule, FormsModule, MatFormFieldModule, MatInputModule, MatMenuModule],
  exports: [MenuInputComponent],
})
export class MenuInputModule {}
